import { Translations } from '@domain/admission';

export interface AdmissionTitleProps {
  setIsOpen: (isOpen: boolean) => void;
  changeOfferName: (name: Translations) => void;
  defaultValue: Translations;
  isEditDisabled?: boolean;
}

export interface Form {
  name: Translations;
  nameLanguage: string;
}

export const OFFER_NAME_MAX_LENGTH = 100;
